// extracted by mini-css-extract-plugin
export default {"Coconut":"#F4F7FA","container":"Gb5d127","layoutContainer":"G6cd18c","pageContainer":"G144b2c"};